module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt_BR":{"password_renew.inform_new_passowrd":"Informe uma nova senha","password_renew.reset":"Resetar"},"en":{"password_renew.inform_new_passowrd":"Enter a new password","password_renew.reset":"Reset"}}')
  delete Component.options._Ctor
}
